export enum EFilterField {
  DEVICE = 'device',
  DEVICES = 'devices',
  VISITOR = 'visitor_type',
  VISITORS = 'visitor_types',
  TRAFFIC_SOURCE = 'traffic_source',
  TRAFFIC_SOURCES = 'traffic_sources',
  VERSION = 'version',
  VERSIONS = 'versions',
  SINGLE_PAGE = 'page_path',
  LIST_PAGE = 'page_paths',
  GROUP_CAMPAIGN_ITEM = 'group_campaign_item',
  GROUP_CAMPAIGN_ITEMS = 'group_campaign_items',
  SINGLE_CAMPAIGN = 'experiment_id',
  GROUP_CAMPAIGN = 'experiment_group_id',
  // UI-only keys: price and URL experiments are campaigns, so they resolve to SINGLE_CAMPAIGN in the query
  PRICE_CAMPAIGN = 'price_experiment_id',
  URL_CAMPAIGN = 'url_experiment_id',
  CAMPAIGN_VERSION_ID = 'version_id',
  GROUP_CAMPAIGN_VERSION_ID = 'group_version_id',
}
